import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-healthcheck',
  templateUrl: './healthcheck.component.html'
})
export class HealthcheckComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
